import ApiService from "@/common/api.service";

export default {
  fetchCounselingProfiles(payload) {
    return ApiService.query("counseling-profiles", payload);
  }
};
